export default __webpack_public_path__ + "static/media/mark-as-bounced.5540d55e.svg";